import { TASK_TYPES } from '../ContentLists/TaskList/constants'

export const TASK_TYPE_TITLE = {
  [TASK_TYPES.absenceRequest]: 'task.headline.absenceRequest',
  [TASK_TYPES.shareUserData]: 'task.headline.shareData',
  [TASK_TYPES.monthlySheet]: 'task.headline.workTime',
  [TASK_TYPES.shiftUpdate]: 'task.headline.shiftUpdate',
  [TASK_TYPES.secureConnection]: 'task.headline.secureConnection',
}
